<template>
    <section class="main_auth_page">
        <div class="auth_page_wrp">
            <slider></slider>
            <sign-up></sign-up>
        </div>
    </section>
</template>

<script>
import Registerform from './registration-form';
import bannerSlider from '@/components/common/banner-slider/';
import { bus } from '@/main';

export default {
    name: 'signup-page',
    components: {
        'sign-up': Registerform,
        'slider' : bannerSlider
    },
    data() {
        return {
        };
    },
    mounted() {
        this.checkAuthAndRedirect();
        bus.$emit('showHeaderbtn', false);
        document.body.classList.add('signup_page_wrp');
    },
    beforeUnmount() {
        document.body.classList.remove('signup_page_wrp');
    },
    methods: {
        checkAuthAndRedirect() {
            if (localStorage.getItem('token') && localStorage.getItem('LoginedUserID')) {
                this.$router.push('/');
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.auth_page_wrp {
    position: relative;
    overflow: hidden;
    min-height: 100dvh;
}
</style>